/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerNavBarItemSX: SxProps = {
	height: '100%',
	minHeight: '66px',
	'&.MuiButton-text': {
		transform: 'none',
		p: { xs: 1.6, lg: 2 },
		backgroundColor: 'transparent',
		color: '#333333',
		position: 'relative',
		fontSize: { xs: '14px', lg: 'var(--font-size-sm)' },
		borderRadius: 0,
		whiteSpace: 'nowrap',
		'&:first-of-type': {
			ml: -2,
		},
		'&:is(a):not([href])': {
			cursor: 'default',
		},
		textDecoration: 'none',
		'&:after': {
			content: '""',
			position: 'absolute',
			left: 0,
			right: 0,
			bottom: '-1px',
			height: '4px',
			backgroundColor: '#000000',
			transform: 'translateY(100%)',
			transition: 'transform 0.2s ease',
			visibility: 'hidden',
		},
		'&:hover:after': {
			transform: 'translateY(0%)',
			visibility: 'visible',
		},
		'&:not(:hover):after': {
			transform: 'translateY(100%)',
			visibility: 'hidden',
		},
	},
};
